export const MAX_PROJECT_NAME_ATTEMPTS = 10
export const MAX_STORE_NAME_ATTEMPTS = 10
export const MAX_NAME_ATTEMPTS = 10
export const MAX_OVERWRITE_PREVIEW_ROWS = 20
